import { IDevicesTabState } from './devicesTabContext';
import { DevicesTabActionTypes, TDevicesTabAction } from './devicesTabActions';

export const devicesTabReducer = (state: IDevicesTabState, action: TDevicesTabAction): IDevicesTabState => {
	switch (action.type) {
		case DevicesTabActionTypes.SET_RESTAURANT_DEVICES:
			return {
				...state,
				restaurantDevices: action.payload.restaurantDevices,
			};
		case DevicesTabActionTypes.CHANGE_DEVICES_TAB_SEARCH_STRING:
			return {
				...state,
				devicesTabSearchString: action.payload.searchString,
				devicesTabCurrentPage: 1,
			};
		case DevicesTabActionTypes.SET_DEVICES_TAB_SORT_BY:
			return {
				...state,
				devicesTabSortBy: action.payload.sortBy,
				devicesTabCurrentPage: 1,
			};
		case DevicesTabActionTypes.SET_DEVICES_TAB_COUNT_OF_ITEMS:
			return {
				...state,
				devicesTabCountOfItems: action.payload.countOfItems,
				devicesTabCurrentPage: 1,
			};
		case DevicesTabActionTypes.CHANGE_DEVICES_TAB_CURRENT_PAGE:
			return {
				...state,
				devicesTabCurrentPage: action.payload.currentPage,
			};
		default:
			return state;
	}
};
